<template>
  <!-- eslint-disable  vue/no-multiple-template-root -->
  <slot></slot>
</template>

<script setup>
import { provide } from 'vue';

const props = defineProps({
  runtime: {
    type: Object,
    default() {
      return { permission: {} };
    },
  },
});

provide('$runtime', JSON.parse(props.runtime));
</script>
